import React from "react";
import Logo from "./Logo";
import { useStateContext } from "../utils/web3";
import discord from "../assets/Discord.png"
import instagram from "../assets/Instagram2.png"
import opensea from "../assets/OpenSea.png"
import twitter from "../assets/Twitter.png"

function Header() {
  const { isConnected, disconnectWallet } = useStateContext();
  return (
    <div className="flex flex-col md:flex-row items-center w-full justify-between p-5 bg-transparent z-20 h-2/6 md:h-1/6">
      <div className="flex items-center justify-around w-full md:w-2/6 h-1/2 md:h-full">
        <Logo/>
        <a href="/" className="leading-normal uppercase txt-primary text-6xl md:text-3xl">About</a>
        <a href="/" className="leading-normal uppercase txt-primary text-6xl md:text-3xl">Utility</a>
      </div>
      <div className="flex h-full items-center">
        <a href="/" className="h-1/4 md:h-2/6 mr-1 md:mr-2">
          <img src={instagram} alt="" className="h-full"/>
        </a>
        <a href="/" className="h-1/4 md:h-2/6 mr-1 md:mr-2">
          <img src={twitter} alt="" className="h-full"/>
        </a>
        <a href="/" className="h-1/4 md:h-2/6 mr-1 md:mr-2">
          <img src={discord} alt="" className="h-full"/>
        </a>
        <a href="/" className="h-1/4 md:h-2/6 mr-1 md:mr-5">
          <img src={opensea} alt="" className="h-full"/>
        </a>
        {
          isConnected && 
          (
            <button onClick={disconnectWallet} className="flex primary-button-bg rounded-full h-fit px-5 py-2">
              <div className="normal-text m-auto leading-normal uppercase txt-white text-6xl md:text-xl">
                {"Disconnect Wallet"}
              </div>
            </button>
          )
        }
      </div>

    </div>
  );
  
}

export default Header;